let active = false;
let desired = false;
let controller = null;
export const meshCoverageRuntime = {
    getActive: () => active,
    setActive: value => { active = !!value; },
    getDesired: () => desired,
    setDesired: value => { desired = !!value; },
    getController: () => controller,
    setController: value => { controller = value; },
    getState: () => ({ widoki3dActive: active, widoki3dDesired: desired }),
};
